<template>
    <div class="row mb-2">
        <div class="col-md-12 col-12">
            <div class="nb-warning">
                <div class="nb-warning-message default" v-for="(err, index) in messages" :key="index">
                    <span>{{ err }}</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'warnings',

    props: {
      messages: { type: Array },
    },

    data () {
        return {
            show: true,
        }
    },

    watch: {
      messages: function() {
       return this.messages
      }
    },

    methods: {
        handleContinueAnyWay(){
          console.log('handlecontinueanyway')
          this.$emit('continueanyway');
        },
        toggleAlert() {
            this.show = false
        }
    },

   mounted(){
   },

   created(){

   },

}
</script>

<style scoped>

.nb-warning {
    box-sizing: border-box;
    height: 100%;
    position: relative;
    margin: 0;
}

.nb-warning-message {
    border-radius: 0 3px 3px 0;
    border: 1px solid;
    border-left: 3px solid;
    padding: 3px;
    padding-left: 10px;
    margin: 3px;
    position: relative;
    font-size: 15px;
}


.nb-warning-message.error {
    /* color: #b98e00; */
    color: #BC1132;
    border-top: 1px solid #F9B3C1;
    border-bottom: 1px solid #F9B3C1;
    border-left: 3px solid #F43E61;
    border-right: 1px solid #F9B3C1;
    /* border-color: #ffdf79 #ffdf79 #ffdf79 #ffc200; */
    background: #fff4ce;
}

.nb-warning-message.default {
    /* color: #b98e00; */
    color: #dfa701;
    border-top: 1px solid #f9eeb3;
    border-bottom: 1px solid #f9eeb3;
    border-left: 3px solid #ffc107;
    border-right: 1px solid #f9eeb3;
    /* border-color: #ffdf79 #ffdf79 #ffdf79 #ffc200; */
    background: #fffbee;
}

.nb-warning.title {
    display: block;
    font-size: 14px;
    font-weight: 700;
}

</style>



// WEBPACK FOOTER //
// src/components/warnings.vue